export default __webpack_public_path__ + "static/media/football logo.adfd5e9f.png";